import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { InvitationEntity } from '../entities/MembershipEntity.js';

export interface GetInvitationByCodeInput { code: string; }

interface Deps { membershipRepository: IMembershipRepository; }
export function createGetInvitationByCodeUseCase({ membershipRepository }: Deps) {
  return async function getInvitationByCode(input: GetInvitationByCodeInput): Promise<InvitationEntity | null> {
    return membershipRepository.getInvitationByCode(input.code);
  };
}